import { createApplicationHooks } from '@/modules/service-requests/shared/application-hooks';
import { changeByodStatus, byodApi, submitByodApplication } from '../services/byod.service';
import { ByodApplication } from '../types/byod.types';

const hooks = createApplicationHooks<ByodApplication>({
  key: 'byod',
  api: byodApi,
  withdrawWorkflow: 'BYOD_APPLICATION_WITHDRAW',
});

export const useByodApplications = hooks.useApplications;
export const useByodApplication = hooks.useApplication;
export const useWithdrawByod = hooks.useWithdrawApplication;

export const useSubmitByod = () =>
  hooks.useApplicationMutation(submitByodApplication, 'REQUEST_SUBMITTED');

export const useChangeByodStatus = () =>
  hooks.useApplicationMutation(changeByodStatus, 'REQUEST_UPDATED');
